import * as Yup from 'yup';

Yup.setLocale({
  mixed: {
    required: 'Campo obrigatório',
  },
  string: {
    email: 'Preencha um e-mail válido',
    min: 'Mínimo de ${min} caracteres',
    max: 'Máximo de ${max} caracteres',
  },
  number: {
    min: 'Deve ser maior ou igual a ${min}',
    max: 'Deve ser menor ou igual a ${max}',
  },
});

const Schema = Yup.object().shape({
  name: Yup.string().min(3).required(),
  corporate_name: Yup.string().min(3),
  fantasy_name: Yup.string().min(3),
  document: Yup.string().required(),
  address: Yup.string().min(3).required(),
  number: Yup.string().required(),
  neighborhood: Yup.string().min(3).required(),
  zipcode: Yup.string().required(),
  uf: Yup.string().required(),
  id_city: Yup.number().required(),
  phone1: Yup.string().required(),
  phone2: Yup.string(),
});
export default Schema;
